module.exports = __webpack_public_path__ + "static/media/2.3d646c65.jpg";